/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zippy_Pink_Rabbit_DartInputs */

const fr_zippy_pink_rabbit_dart = /** @type {(inputs: Zippy_Pink_Rabbit_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informations générales`)
};

/**

* @param {Zippy_Pink_Rabbit_DartInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const zippy_pink_rabbit_dart = /** @type {((inputs?: Zippy_Pink_Rabbit_DartInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zippy_Pink_Rabbit_DartInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_zippy_pink_rabbit_dart(inputs)
});